import React from "react";
import SiteHeader from "../SiteHeader";
import SiteFooter from "../SiteFooter";
import MenuItemBuyTicketContainer from "../SiteNavigation/MenuItemBuyTicket/MenuItemBuyTicketContainer";
import isIframe from "../functions/isIframe";
import getAdvertisementData from "../functions/getAdvertisementData";
import { ADVERTISEMENT_FIREPLACE } from "../constants/advertisementTypes";
import AdvertisementsFireplace from "../Advertisements/AdvertisementFireplace";

const WrapperReactPage = ({
  children,
  translation,
  movies,
  extraClass = "",
  advertisements,
  isScrolledClass,
  hasChatbot,
  headerAppearance,
  contentWidth,
  features,
  buyTicketAnimation = false,
}) => {
  const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_FIREPLACE]) 
  const stickyHeaderClass = (filteredAdvertisements[ADVERTISEMENT_FIREPLACE].length !== 0 || headerAppearance === 'filled_with_color') ? 'is-sticky-menu' : ''
  const filledWithColorClass = headerAppearance === 'filled_with_color' ? ' colored-header' : headerAppearance === 'partly_filled_with_color' ? ' partly-colored-header' : ''
  const loginHeaderClass = features && features.has_userbar ? ' large-header' : ''

  if(document.body && document.body.classList) {
    const elementorClasses = _.filter(document.body.classList, classItem => {
      if(classItem.search("elementor") !== -1) {
        return classItem
      }
    })

    elementorClasses.map(elementorClass => {
      document.body.classList.remove(elementorClass)
    })
    document.body.classList.remove('elementor-page')
  }

  return (
    <div className="site-inner">
      {filteredAdvertisements[ADVERTISEMENT_FIREPLACE].length !== 0 && <AdvertisementsFireplace className={isScrolledClass} items={filteredAdvertisements[ADVERTISEMENT_FIREPLACE]} />}
      {!isIframe() && (
        <header id="site-header" className={stickyHeaderClass + filledWithColorClass + loginHeaderClass}>
          <SiteHeader />
        </header>
      )}
      <div id="content" className={"site-content " + contentWidth}>
        <div id="primary" className="content-area">
          <main id="main" className={"site-main" + extraClass} role="main">
            {children}
          </main>
        </div>
        {hasChatbot && <div id="menu-item-chatbot-container"></div>}
        {movies && (
          <MenuItemBuyTicketContainer
            movies={movies.items}
            moviesOrder={movies.order}
            translation={translation}
            buyTicketAnimation={buyTicketAnimation}
            filledWithColorClass={filledWithColorClass}
          />
        )}
      </div>
      {!isIframe() && (
        <footer id="site-footer">
          <SiteFooter />
        </footer>
      )}
    </div>
  );
};

export default WrapperReactPage;
